import { render, staticRenderFns } from "./ImgUploader.vue?vue&type=template&id=1ef912eb&"
import script from "./ImgUploader.vue?vue&type=script&lang=js&"
export * from "./ImgUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports